/**
 * 3-rule visual password-strength hint.
 * Pure render — no state. Used in the Create User + Reset Password flows.
 */
export default function PasswordHint({ value }) {
  const checks = [
    { label: "8+ characters", ok: value.length >= 8 },
    { label: "Contains a letter", ok: /[a-zA-Z]/.test(value) },
    { label: "Contains a number", ok: /\d/.test(value) },
  ];
  return (
    <ul className="mt-1.5 grid grid-cols-3 gap-1.5">
      {checks.map((c) => (
        <li
          key={c.label}
          className={`text-[11px] flex items-center gap-1 ${
            c.ok ? "text-emerald-600" : "text-clinical-subtext"
          }`}
        >
          <span
            className={`inline-block h-1.5 w-1.5 rounded-full ${
              c.ok ? "bg-emerald-500" : "bg-clinical-border"
            }`}
          />
          {c.label}
        </li>
      ))}
    </ul>
  );
}
